import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef, useRef, useCallback } from "react";
import { useTextBasedInput } from "../hooks/useTextBasedInput.js";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toViewClass } from "../../../utils/toViewClass.js";
const FloatInput = memo(
  forwardRef(({
    className,
    defaultValue,
    onChange,
    max,
    min,
    value,
    withTopToolbar,
    ...outerProps
  }, forwardedRed) => {
    const number = useRef();
    const props = useTextBasedInput({
      ...outerProps,
      className: classNames(
        useComponentClassName("text-input"),
        useComponentClassName("number-input"),
        toViewClass("withTopToolbar", withTopToolbar),
        className
      ),
      defaultValue: defaultValue?.toString(10),
      max: max?.toString(10),
      min: min?.toString(10),
      onChange: useCallback((value2) => {
        value2 = typeof value2 === "string" && value2.trim() !== "" ? value2.replaceAll(",", ".").replace(/[^\d.-]/g, "").replace(/^(\d+\.\d+|\d+).*/, "$1").replace(/^0*(?=\d)/, "") : "";
        if (number.current !== value2) {
          number.current = value2;
          onChange?.(value2 ? parseFloat(value2) : null);
        }
      }, [onChange]),
      value: value?.toString(10)
    }, forwardedRed);
    return /* @__PURE__ */ jsx("input", { ...props, type: "number", step: outerProps.step ?? "any" });
  })
);
FloatInput.displayName = "FloatInput";
export {
  FloatInput
};
//# sourceMappingURL=FloatInput.js.map
